var _radialGradient, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradient1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "2560px",
    height: "2560px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2560 2560",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient_id0",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.04282 1.85764 -1.88352 1.96302 91 -169)",
    cx: 51.1996,
    cy: 76.8,
    r: 691.2,
    fx: 51.1996,
    fy: 76.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#8686FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521569,
    style: {
      stopOpacity: 1,
      stopColor: "#8A89FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "#8D8BFF"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient_id1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.99479 -1.44792 1.45808 -1.20752 3501 8329)",
    cx: 2278.4,
    cy: 2278.4,
    r: 768,
    fx: 2278.4,
    fy: 2278.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#DFBFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "#E4C3FF"
    }
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient_id2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-0.113639 1.29261 -2.02129 -0.0892874 1648 -1825)",
    xlinkHref: "#id0",
    cx: 1433.6,
    cy: 25.6004,
    r: 281.6,
    fx: 1433.6,
    fy: 25.6004
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient_id3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.74716 -1.73295 1.15057 -1.16477 4184 8559)",
    cx: 2380.8,
    cy: 2048,
    r: 844.8,
    fx: 2380.8,
    fy: 2048
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#F0B9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560784,
    style: {
      stopOpacity: 1,
      stopColor: "#CC89F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "#A95AE5"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient_id4",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.0477 1.49671 -0.742955 -2.28335 7988 -2242)",
    cx: 2508.8,
    cy: 460.8,
    r: 486.401,
    fx: 2508.8,
    fy: 460.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#7C33AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368627,
    style: {
      stopOpacity: 1,
      stopColor: "#9347C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "#A95AE5"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient_id5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.90194 1.86422 -0.75431 -1.54095 7135 -4274)",
    cx: 2432,
    cy: 102.4,
    r: 742.4,
    fx: 2432,
    fy: 102.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#7435A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "#6F289F"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient_id6",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.14063 -1.6183 0.825073 2.40296 -2102 -3210)",
    cx: 102.4,
    cy: 2406.4,
    r: 896,
    fx: 102.4,
    fy: 2406.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#4A3EA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368627,
    style: {
      stopOpacity: 1,
      stopColor: "#493DA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "#493CA6"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#B36AF4",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gradient_id2)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gradient_id5)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gradient_id1)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gradient_id0)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gradient_id6)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gradient_id4)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gradient_id3)",
    width: 2560,
    height: 2560
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient1);
export default __webpack_public_path__ + "static/media/gradient1.5aee9d0c99d600c9e5442843d691f952.svg";
export { ForwardRef as ReactComponent };